"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadSuits = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var RadSuits = (function (_super) {
    __extends(RadSuits, _super);
    function RadSuits() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.RAD_SUITS,
            cost: 6,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.cities(2).any(); }),
            metadata: {
                cardNumber: '186',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1); });
                }),
                description: 'Requires two cities in play. Increase your M€ production 1 step.',
                victoryPoints: 1,
            },
        }) || this;
    }
    RadSuits.prototype.play = function (player) {
        if (player.game.getCitiesInPlay() < 2) {
            throw 'Must have 2 cities in play';
        }
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        return undefined;
    };
    RadSuits.prototype.getVictoryPoints = function () {
        return 1;
    };
    return RadSuits;
}(Card_1.Card));
exports.RadSuits = RadSuits;
//# sourceMappingURL=RadSuits.js.map